<template>
<div
  class="pearlie-sue"
  :class="{
    'full-body': fullBody,
    'shakers': shakers,
    'eyes-half': eyesState === 'half',
    'eyes-closed': eyesState === 'closed',
    'mouth-open': mouthState === 'open',
    'mouth-open-teeth': mouthState === 'open-teeth',
    'mouth-teeth': mouthState === 'teeth',
    'mouth-o': mouthState === 'o'
  }"
>
  <div class="pearlie-sue__eyebrows"></div>
  <div class="pearlie-sue__eyes-open"></div>
  <div class="pearlie-sue__eyes-half"></div>
  <div class="pearlie-sue__eyes-closed"></div>
  <div class="pearlie-sue__mouth-closed"></div>
  <div class="pearlie-sue__mouth-open"></div>
  <div class="pearlie-sue__mouth-open-teeth"></div>
  <div class="pearlie-sue__mouth-teeth"></div>
  <div class="pearlie-sue__mouth-o"></div>
  <div class="pearlie-sue__arm-point"></div>
  <div class="pearlie-sue__arm-shaker-left"></div>
  <div class="pearlie-sue__arm-shaker-right"></div>
</div>
</template>

<script>
export default {
  name: 'pearlieSue',
  props: {
    fullBody: Boolean,
    speakDuration: Number,
    shakers: Boolean
  },
  data () {
    return {
      eyesState: '',
      eyesTimeCounter: 0,
      eyesInterval: null,
      eyesIntervalPeriod: 100,
      mouthState: '',
      mouthTimeCounter: 0,
      mouthInterval: null,
      mouthIntervalPeriod: 200
    }
  },
  mounted () {
    // Eyes
    clearInterval(this.eyesInterval)
    this.eyesInterval = setInterval(() => {
      if (this.eyesTimeCounter === (this.eyesIntervalPeriod * 50)) {
        this.eyesState = 'half'
        this.eyesTimeCounter += this.eyesIntervalPeriod
      } else if (this.eyesTimeCounter === (this.eyesIntervalPeriod * 51)) {
        this.eyesState = 'closed'
        this.eyesTimeCounter = 0
      } else {
        this.eyesState = ''
        this.eyesTimeCounter += this.eyesIntervalPeriod
      }
    }, this.eyesIntervalPeriod)
  },
  methods: {
    speak () {
      this.mouthState = ''
      this.mouthTimeCounter = 0
      clearInterval(this.mouthInterval)
      this.mouthInterval = setInterval(() => {
        if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 5) === 0) {
          this.mouthState = 'open'
        } else if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 4) === 0) {
          this.mouthState = 'teeth'
        } else if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 3) === 0) {
          this.mouthState = ''
        } else if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 2) === 0) {
          this.mouthState = 'open-teeth'
        } else if (this.mouthTimeCounter % this.mouthIntervalPeriod === 0) {
          this.mouthState = 'o'
        }
        if (this.mouthTimeCounter >= this.speakDuration) {
          this.mouthState = ''
          this.mouthTimeCounter = 0
          clearInterval(this.mouthInterval)
        } else {
          this.mouthTimeCounter += this.mouthIntervalPeriod
        }
      }, this.mouthIntervalPeriod)
    }
  },
  beforeDestroy () {
    clearInterval(this.eyesInterval)
    clearInterval(this.mouthInterval)
  }
}
</script>

<style lang="scss">
@keyframes ps-eyebrows {
  0% {
    transform: translate3d(0,0%,0);
  }
  20% {
    transform: translate3d(0,0%,0);
  }
  30% {
    transform: translate3d(0,-15%,0);
  }
  40% {
    transform: translate3d(0,0%,0);
  }
  60% {
    transform: translate3d(0,0%,0);
  }
  70% {
    transform: translate3d(0,-15%,0);
  }
  80% {
    transform: translate3d(0,0%,0);
  }
  100% {
    transform: translate3d(0,0%,0);
  }
}
@keyframes ps-shaker-left {
  0% {
    transform: rotate3d(0,0,1,20deg);
  }
  50% {
    transform: rotate3d(0,0,1,-10deg);
  }
  100% {
    transform: rotate3d(0,0,1,20deg);
  }
}
@keyframes ps-shaker-right {
  0% {
    transform: rotate3d(0,0,0,0deg);
  }
  50% {
    transform: rotate3d(0,0,1,-30deg);
  }
  100% {
    transform: rotate3d(0,0,0,0deg);
  }
}
.pearlie-sue {
  position: relative;
  width: fluid(196px);
  height: fluid(271px);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-image: url('~@/assets/img/pearlie-sue-body-half.svg');
  transform-origin: 0% 0%;
  &__arm-point {
    position: absolute;
    bottom: fluid(19px);
    left: 0;
    width: fluid(142px);
    height: fluid(70px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-arm-point.svg');
  }
  &__arm-shaker-left {
    display: none;
    position: absolute;
    bottom: fluid(30px);
    right: fluid(-20px);
    width: fluid(124px);
    height: fluid(115px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-arm-shaker-left.svg');
    transform-origin: 75% 75%;
    transform: rotate3d(0,0,1,20deg);
  }
  &__arm-shaker-right {
    display: none;
    position: absolute;
    bottom: fluid(19px);
    left: 0;
    width: fluid(150px);
    height: fluid(81px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-arm-shaker-right.svg');
    transform-origin: 25% 50%;
  }
  &__eyebrows {
    position: absolute;
    top: fluid(64px);
    left: fluid(77px);
    width: fluid(50px);
    height: fluid(20px);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-eyebrows.svg');
    animation: ps-eyebrows 8s linear infinite;
  }
  &__eyes-open {
    position: absolute;
    top: fluid(76px);
    left: fluid(80px);
    width: fluid(45px);
    height: fluid(20px);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-eyes-open.svg');
  }
  &__eyes-half {
    display: none;
    position: absolute;
    top: fluid(78px);
    left: fluid(80px);
    width: fluid(45px);
    height: fluid(20px);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-eyes-half.svg');
  }
  &__eyes-closed {
    display: none;
    position: absolute;
    top: fluid(80px);
    left: fluid(80px);
    width: fluid(45px);
    height: fluid(20px);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-eyes-closed.svg');
  }
  &__mouth-closed {
    position: absolute;
    top: fluid(105px);
    left: fluid(95px);
    width: fluid(30px);
    height: fluid(11px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-closed.svg');
  }
  &__mouth-open {
    display: none;
    position: absolute;
    top: fluid(104px);
    left: fluid(94px);
    width: fluid(30px);
    height: fluid(14px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-open.svg');
  }
  &__mouth-open-teeth {
    display: none;
    position: absolute;
    top: fluid(103px);
    left: fluid(95px);
    width: fluid(30px);
    height: fluid(13px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-open-teeth.svg');
  }
  &__mouth-teeth {
    display: none;
    position: absolute;
    top: fluid(104px);
    left: fluid(97px);
    width: fluid(30px);
    height: fluid(13px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-teeth.svg');
  }
  &__mouth-o {
    display: none;
    position: absolute;
    top: fluid(104px);
    left: fluid(98px);
    width: fluid(30px);
    height: fluid(14px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-o.svg');
  }
  &.full-body {
    width: fluid(280px);
    height: fluid(644px);
    background-image: url('~@/assets/img/pearlie-sue-body-full.svg');
    .pearlie-sue {
      &__arm-point {
        display: none;
      }
      &__eyebrows {
        top: fluid(87px);
        left: fluid(122px);
        width: fluid(72px);
        height: fluid(17px);
      }
      &__eyes-open {
        top: fluid(105px);
        left: fluid(131px);
        width: fluid(59px);
        height: fluid(17px);
      }
      &__eyes-half {
        top: fluid(109px);
        left: fluid(131px);
        width: fluid(59px);
        height: fluid(17px);
      }
      &__eyes-closed {
        top: fluid(110px);
        left: fluid(131px);
        width: fluid(59px);
        height: fluid(17px);
      }
      &__mouth-closed {
        top: fluid(142px);
        left: fluid(146px);
        width: fluid(59px);
        height: fluid(17px);
      }
      &__mouth-open {
        top: fluid(141px);
        left: fluid(146px);
        width: fluid(59px);
        height: fluid(20px);
      }
      &__mouth-open-teeth {
        top: fluid(140px);
        left: fluid(146px);
        width: fluid(59px);
        height: fluid(19px);
      }
      &__mouth-teeth {
        top: fluid(140px);
        left: fluid(150px);
        width: fluid(59px);
        height: fluid(19px);
      }
      &__mouth-o {
        top: fluid(140px);
        left: fluid(152px);
        width: fluid(59px);
        height: fluid(21px);
      }
    }
  }
  &.shakers {
    .pearlie-sue {
      &__arm-point {
        display: none;
      }
      &__arm-shaker-left,
      &__arm-shaker-right {
        display: block;
      }
    }
  }
  &.eyes-half {
    .pearlie-sue {
      &__eyes-open {
        display: none;
      }
      &__eyes-half {
        display: block;
      }
    }
  }
  &.eyes-closed {
    .pearlie-sue {
      &__eyes-open {
        display: none;
      }
      &__eyes-closed {
        display: block;
      }
    }
  }
  &.mouth-open {
    .pearlie-sue {
      &__mouth-closed {
        display: none;
      }
      &__mouth-open {
        display: block;
      }
    }
  }
  &.mouth-open-teeth {
    .pearlie-sue {
      &__mouth-closed {
        display: none;
      }
      &__mouth-open-teeth {
        display: block;
      }
    }
  }
  &.mouth-teeth {
    .pearlie-sue {
      &__mouth-closed {
        display: none;
      }
      &__mouth-teeth {
        display: block;
      }
    }
  }
  &.mouth-o {
    .pearlie-sue {
      &__mouth-closed {
        display: none;
      }
      &__mouth-o {
        display: block;
      }
    }
  }
}
.shaking-shakers {
  .pearlie-sue {
    &__arm-shaker-left {
      animation: ps-shaker-left 0.5s linear infinite;
    }
    &__arm-shaker-right {
      animation: ps-shaker-right 0.5s linear infinite;
    }
  }
}
</style>